import Tile from 'features/tiles/tile';
import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC } from 'react';

const NotFound: FC = () => {
  return (
    <>
      <TileGridContainer>
        <Tile className="w-full flex-wrap flex flex-col">
          <p className="self-start">Page Not Found.</p>
        </Tile>
      </TileGridContainer>
    </>
  );
};

export default NotFound;
